import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings'
import { BaseClientConfig } from 'common/client/BaseClientConfig'
import { homeSegment } from './home-segment'
import { politicsSegment } from './politics-segment'
import { inCaseYouMissedItSegment } from './in-case-you-missed-it-segment'
import { yourMoneySegment } from './your-money-segment'
import { aflSegment } from './afl-segment'
import { moreSportSegment } from './more-sport-segment'
import { opinionSegment } from './opinion-segment'
import { insideCoverSegment } from './inside-cover-segment'
import { businessSegment } from './business-segment'
import { propertySegment } from './property-segment'
import { foodAndDrinkSegment } from './food-and-drink-segment'
import { brandContentSegment } from './brand-content-segment'
import { regionalSegment } from './regional-segment'
import { travelSegment } from './travel-segment'
import { subscriberExclusive } from './subscriber-exclusive'
import { miscCollectionsSegment } from './misc-collections-segment'
import { entertaimentAndLifestyleSegment } from './entertainment-lifestyle-segment'
import { StaticRoutes } from 'common/routing/page-definition'
import { telethonCountdown } from './telethon-countdown'
import { billboardLeaderboardMrec } from '../ad-units'
import { sportFeaturedSegment } from './sport-featured-segment'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

const rampAdUnit = layout.component({
    type: 'ad-unit',
    props: {
        noticePosition: 'none',
        hiddenUntilLoaded: true,
        padding: [0, 0, metrics.thewest.margins.lg, 0],
        slot: {
            id: 'ramp',
            size: 'ramp',
            exclusionLabels: ['NoAds'],
        },
    },
})

const outBrain = (config: BaseClientConfig) =>
    layout.component({
        type: 'outbrain-ad',
        feature: 'outbrain-homepage',
        props: {
            widgetId: 'AR_2',
            link: config.outbrainUrl,
            template: 'TheWestAustralian',
        },
    })

export const homepage: StaticRoutes<typeof layout, TheWestSection> = {
    '': ({ config, getAdTargeting }) => ({
        kind: 'page',
        heading: 'The West Australian | Perth, WA, National & World News',
        pageType: 'homepage',
        hideHeading: true,
        refreshOnInactive: true,
        noMetaTitleTemplate: true,
        pageMeta: {
            title: 'The West Australian | Perth, WA, National & World News',
            description:
                'The West Australian is a leading news source in Perth and WA. Breaking local and world news from sport and business to lifestyle and current affairs.',
        },
        adTargeting: getAdTargeting('home', 'default', 'home'),
        section: 'default',
        compositions: [
            mainContentSection(
                subscriberExclusive(),
                telethonCountdown,
                inCaseYouMissedItSegment,
                rampAdUnit,
                politicsSegment,
                entertaimentAndLifestyleSegment,
                ...billboardLeaderboardMrec('one'),
                ...aflSegment,
                sportFeaturedSegment,
                moreSportSegment,
                ...billboardLeaderboardMrec('two'),
                ...businessSegment,
                opinionSegment,
                insideCoverSegment,
                ...billboardLeaderboardMrec('three'),
                yourMoneySegment,
                propertySegment,
                foodAndDrinkSegment,
                ...brandContentSegment
            ),
            lowerContentSection(
                regionalSegment,
                ...travelSegment,
                miscCollectionsSegment,
                outBrain(config)
            ),
        ],
    }),
}

function mainContentSection(
    ...components: typeof layout._componentType[]
): typeof layout._compositionType {
    return {
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: metrics.thewest.mainContentWidth,
            horizontalGutters: false,
            verticalGutters: false,
        },
        contentAreas: {
            main: [
                homeSegment,
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: components,
                    },
                }),
            ],
        },
    }
}

function lowerContentSection(
    ...components: typeof layout._componentType[]
): typeof layout._compositionType {
    return layout.composition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: metrics.thewest.mainContentWidth,
            horizontalGutters: false,
        },
        contentAreas: {
            main: [
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: true,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: components,
                    },
                }),
            ],
        },
    })
}
